import { ApiResult, PaginatedResponse } from '@synergy/api';
import { PurchaseOrderTransition } from '@synergy/models';
import { request, safeRequest } from '@synergy/api';

import { DemandTransition } from './models/demand/demandTransition';
import { Inquiry } from '../inquiries/models/inquiry';
import { Invoice } from '../invoices/models/invoice';
import { OfferTransition } from './models/offer/offerTransition';
import { PurchaseOrder } from '../purchase-orders/models/purchaseOrder';
import { SalesOrderTransition } from './models/sales-order/salesOrdersTransition';

export class TransitionsApi {
    constructor(protected baseUrl: string) {}

    public inquiryIntoPurchaseOrdersTransition(transitionObject: OfferTransition): Promise<ApiResult<PurchaseOrder[]>> {
        return safeRequest<PurchaseOrder[], PaginatedResponse<PurchaseOrder>>(
            () =>
                request.post(`${this.baseUrl}/transitions/inquiry-into-purchase-orders`, transitionObject, {
                    params: { isSync: true },
                }),
            response => response.data.items.map(PurchaseOrder.fromPlainObject)
        );
    }

    public salesOrderIntoPurchaseOrdersTransition(
        transitionObject: SalesOrderTransition
    ): Promise<ApiResult<PurchaseOrder[]>> {
        return safeRequest<PurchaseOrder[], PaginatedResponse<PurchaseOrder>>(
            () =>
                request.post(`${this.baseUrl}/transitions/sales-order-into-purchase-orders`, transitionObject, {
                    params: { isSync: true },
                }),
            response => response.data.items.map(PurchaseOrder.fromPlainObject)
        );
    }

    public salesOrderIntoInquiriesTransition(transitionObject: SalesOrderTransition): Promise<ApiResult<Inquiry[]>> {
        return safeRequest<Inquiry[], PaginatedResponse<Inquiry>>(
            () =>
                request.post(`${this.baseUrl}/transitions/sales-order-into-inquiries`, transitionObject, {
                    params: { isSync: true },
                }),
            response => response.data.items.map(Inquiry.fromPlainObject)
        );
    }

    public demandIntoPurchaseOrdersTransition(transitionObject: DemandTransition): Promise<ApiResult<PurchaseOrder[]>> {
        return safeRequest<PurchaseOrder[], PaginatedResponse<PurchaseOrder>>(
            () =>
                request.post(`${this.baseUrl}/transitions/demand-into-purchase-orders`, transitionObject, {
                    params: { isSync: true },
                }),
            response => response.data.items.map(PurchaseOrder.fromPlainObject)
        );
    }

    public demandIntoInquiriesTransition(transitionObject: DemandTransition): Promise<ApiResult<Inquiry[]>> {
        return safeRequest<Inquiry[], PaginatedResponse<Inquiry>>(
            () =>
                request.post(`${this.baseUrl}/transitions/demand-into-inquiries`, transitionObject, {
                    params: { isSync: true },
                }),
            response => response.data.items.map(Inquiry.fromPlainObject)
        );
    }

    public purchaseOrderIntoInvoiceTransition(
        transitionObject: PurchaseOrderTransition
    ): Promise<ApiResult<Invoice[]>> {
        return safeRequest<Invoice[], PaginatedResponse<Invoice>>(
            () =>
                request.post(`${this.baseUrl}/transitions/purchase-order-into-invoices`, transitionObject, {
                    params: { isSync: true },
                }),
            response => response.data.items.map(Invoice.fromPlainObject)
        );
    }

    public purchaseOrderIntoCreditTransition(transitionObject: PurchaseOrderTransition): Promise<ApiResult<Invoice[]>> {
        return safeRequest<Invoice[], PaginatedResponse<Invoice>>(
            () =>
                request.post(`${this.baseUrl}/transitions/purchase-order-into-credits`, transitionObject, {
                    params: { isSync: true },
                }),
            response => response.data.items.map(Invoice.fromPlainObject)
        );
    }
}
